module.exports = __webpack_public_path__ + "static/media/icon_explain.32360bd0.svg";